import { render, staticRenderFns } from "./errorComponent.vue?vue&type=template&id=a54e39ee&scoped=true&"
import script from "./errorComponent.vue?vue&type=script&lang=js&"
export * from "./errorComponent.vue?vue&type=script&lang=js&"
import style0 from "./errorComponent.vue?vue&type=style&index=0&id=a54e39ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54e39ee",
  null
  
)

export default component.exports